<app-stepper-container [formGroup]="examForm" #stepper>

  <ng-container more-tools>
    <button
      class="inline-flex items-center justify-center bg-transparent hover:bg-red-500 text-red-700 font-semibold hover:text-white py-3 px-3 border border-red-500 hover:border-transparent rounded-full"
      (click)="requestDelete()" tooltip="Delete" tooltipPosition="left"><span
        class="material-icons">delete</span></button>
  </ng-container>


  <cdk-step label="Exam Details">
    <app-exam-assign
      (coursesList)="courses = $event"
      (subsectionsList)="subsections = $event"
      [isEdit]="isEdit"
      #assignref
      formGroupName="assign"
      class="flex flex-1 p-6">
    </app-exam-assign>
  </cdk-step>
  <cdk-step label="Exam Parts">
    <app-exam-construct formGroupName="construct" class="flex flex-col flex-1 justify-between p-6"></app-exam-construct>
  </cdk-step>
  <cdk-step label="Conditional Flow">
    <app-exam-link formArrayName="flows" class="flex flex-col flex-1 justify-between p-6"></app-exam-link>
  </cdk-step>
  <cdk-step label="Summary">
    @if (courses.length > 0 && subsections.length > 0) {
      <app-exam-summary class="flex flex-1 p-6" [courses]="courses" [subsections]="subsections"></app-exam-summary>
    } @else {
      <div class="flex flex-1 p-6">Loading summary...</div>
    }
  </cdk-step>

  <ng-container button-row>
    @if (whoLastTouchedThisExam != null) {
      <div class="text-xs flex items-center text-[#8B96A2] mr-2">
        Saved
        @if (whoLastTouchedThisExam.who != null) {
          by
          {{whoLastTouchedThisExam.who}}
        }
        at
        {{whoLastTouchedThisExam.when | date: 'short' }}
      </div>
    }
    <outline-button [marginRight]="true" (click)="cancelClick()" text="Cancel" />
    <full-button [marginRight]="true" (click)="formValidation(false)" text="Save" />
    <full-button (click)="formValidation(true)" text="Save & Exit" />
  </ng-container>


</app-stepper-container>
